import { jsx as _jsx } from "react/jsx-runtime";
import { Radio } from "@mui/material";
import { forwardRef } from "react";
export const UiRadio = forwardRef((props, ref) => (_jsx(Radio, Object.assign({ ref: ref }, props))));
//# sourceMappingURL=ui_radio.js.map